import { AGGREGATE_NAMES } from 'cpool-constants';
import type { KeepStateOptions } from 'react-hook-form';

import { APICommunicator } from '~/api/APICommunicator.ts';
import type { SetSubmitStatus } from '~/features/leadDetails/context/LeadDetailsFormContext.tsx';

const submitCommands = async (
    leadId: string,
    setSubmitStatus: SetSubmitStatus,
    commands: { commandName: string; payload: Record<string, unknown> }[],
    formReset?: (values: never, options?: KeepStateOptions) => void,
) => {
    const errors = [];
    const largestPosition = { forms: 0, notes: 0 };
    // eslint-disable-next-line no-restricted-syntax
    for (const command of commands) {
        try {
            // eslint-disable-next-line no-await-in-loop
            const result = await APICommunicator.sendCommand({
                aggregateId: leadId,
                aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
                commandName: command.commandName,
                payload: command.payload,
            });
            if (result?.position) {
                largestPosition.notes = Math.max(largestPosition.notes, result.position);
                if (command.commandName !== 'deleteApplicantNotes') {
                    largestPosition.forms = Math.max(largestPosition.forms, result.position);
                }
            }
        } catch (error) {
            errors.push(error);
        }
    }
    if (errors.length > 0) {
        setSubmitStatus({
            changes: true,
            error: errors,
            position:
                commands.length > errors.length && (largestPosition.forms || largestPosition.notes)
                    ? largestPosition
                    : undefined,
            saved: commands.length > errors.length,
        });
        return;
    }
    if (commands.length > 0) {
        // Reset the corresponding form so that dirtyFields are reset
        if (formReset) formReset({} as never, { keepValues: true });
        setSubmitStatus({
            changes: true,
            commands: commands.map((command) => command.commandName),
            position: largestPosition,
            saved: true,
        });
        return;
    }
    setSubmitStatus({ changes: false, saved: false });
};

export { submitCommands };
